import { env } from './.env';
const runtimeEnv = (window as any)['env'];

export const customEnvironment: any = {
  production: false,
  version: env.npm_package_version + '-dev',
  domain: runtimeEnv?.domain,
  subDomain: runtimeEnv?.subDomain,
  serverUrl: runtimeEnv?.serverUrl,
  defaultLanguage: runtimeEnv?.defaultLanguage,
  supportedLanguages: runtimeEnv?.supportedLanguages,
  dummyDataLoader: runtimeEnv?.dummyDataLoader,
  saasAdminUrl: runtimeEnv?.saasAdminUrl,
  geoSearchProviderUrl: runtimeEnv?.geoSearchProviderUrl,
  sensorStompConfig: {
    url: runtimeEnv?.sensorStomp_url,
    headers: {},
    heartbeat_in: 0,
    heartbeat_out: 50000,
    reconnect_delay: 0,
    debug: false,
  },
  saasEnvironmentSubdomain: runtimeEnv?.saasEnvironmentSubdomain,
};
